import { InputNumber, type InputNumberProps } from '@aigc/antd';
import type { NumberRangeTuple } from '@aigc/types';
import clsx from 'clsx';
import { useCallback, useState, type Ref } from 'react';
import S from './number-range.module.less';

type InnerInputNumberProps = Pick<
  InputNumberProps,
  'placeholder' | 'className' | 'classNames' | 'min' | 'max' | 'precision'
>;

export interface NumberRangeProps {
  ref?: Ref<HTMLDivElement>;
  className?: string;
  value?: NumberRangeTuple;
  onChange?: (value?: NumberRangeTuple) => void;
  onFocus?: InputNumberProps['onFocus'];
  onBlur?: InputNumberProps['onBlur'];
  min?: InnerInputNumberProps;
  max?: InnerInputNumberProps;
}

export const NumberRange = ({
  value,
  onFocus,
  onBlur,
  onChange,
  min,
  max,
  ...props
}: NumberRangeProps) => {
  const [focused, setFocused] = useState(false);
  const [minValue, maxValue] = value ?? [];

  const _onFocus = useCallback<NonNullable<InputNumberProps['onFocus']>>(
    (e) => {
      setFocused(true);
      onFocus?.(e);
    },
    [onFocus],
  );

  const _onBlur = useCallback<NonNullable<InputNumberProps['onBlur']>>(
    (e) => {
      setFocused(false);
      onBlur?.(e);
    },
    [onBlur],
  );

  return (
    <div
      {...props}
      className={clsx(S['number-range'], 'flex items-center', props.className, {
        [S['number-range-focused']!]: focused,
      })}
    >
      <InputNumber
        placeholder="最小值"
        {...min}
        value={minValue}
        controls={false}
        variant="borderless"
        className={clsx(min?.className, S['override'])}
        onChange={(value) => {
          onChange?.([value, maxValue]);
        }}
        onFocus={_onFocus}
        onBlur={_onBlur}
      ></InputNumber>
      <div className={S['sperator']}>~</div>
      <InputNumber
        placeholder="最大值"
        {...min}
        value={maxValue}
        controls={false}
        variant="borderless"
        className={clsx(max?.className, S['override'])}
        onChange={(value) => {
          onChange?.([minValue, value]);
        }}
        onFocus={_onFocus}
        onBlur={_onBlur}
      ></InputNumber>
    </div>
  );
};
